module.exports = __webpack_public_path__ + "static/media/tatara.aeed6bac.PNG";